import { DivisionPolitica } from './../../../_models/division-politica';
import { DivisionPoliticaService } from './../../../_services/division-politica.service';
import { Localizaciones } from './../../../_models/localizaciones';
import { LocalizacionesComponent } from './../../../shared/localizaciones/localizaciones.component';
import { DialogService } from 'primeng/dynamicdialog';
import { ListaItem } from './../../../_models/lista-item';
import { SelectItem } from 'primeng/api';
import { ListaService } from './../../../_services/lista.service';
import { PoliticasDuraService } from './../../../_services/politicas-dura.service';
import { PoliticaDura } from './../../../_models/politica-duras';
import { NavService } from './../../../_services/_nav.service';
import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Location } from '@angular/common';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import { log } from 'console';
import { PoliticasDurasDivisionesPoliticasService } from '../../../_services/politicas-duras-divisiones-politicas.service';
import { PoliticaDuraDivisionPolitica } from '../../../_models/politica-dura-division-politica';
import { Table } from 'primeng/table';
@Component({
  selector: 'app-politicas-duras-editar',
  templateUrl: './politicas-duras-editar.component.html',
  styleUrls: ['./politicas-duras-editar.component.css'],
})
export class PoliticasDurasEditarComponent implements OnInit, AfterViewInit {
  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  policaDura: PoliticaDura;

  lisPoliticasDuras: ListaItem[] = [];
  lisTiposDocumentos: SelectItem[] = [];
  selectPoliticasDuras: SelectItem[] = [];
  politicasDurasTodos: PoliticaDura[] = [];
  tabSeleccionado = 'INFO';
  formulario: FormGroup;
  submitted = false;
  codigoValidacion = '';

  // Localizaciones

  listNeighborhoods: SelectItem[] = [];
  hoodList: any;
  neighborhoods: any;
  badSelect = false;
  badSelectBarrio = true;
  localizacion: Localizaciones = new Localizaciones();
  city: any;
  divisionPadre: any;
  ciudadesSeleccionadas: PoliticaDuraDivisionPolitica[] = [];
  columnas = []
  politicasDurasDivisionesPoliticas: PoliticaDuraDivisionPolitica[] = [];
  carPoliticasDuras = true;
  busqueda: string;
  politicasDurasHabilitadas: PoliticaDura[] = [];
  @ViewChild('dt') table: Table;


  constructor(
    private nav: NavService,
    private polDuraService: PoliticasDuraService,
    private location: Location,
    private conServicio: ConfirmationService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private fb: FormBuilder,
    private politicalDivisionServices: DivisionPoliticaService,
    private autServicio: AutenticacionService,
    private politicasDurasDivisionesPoliticasService: PoliticasDurasDivisionesPoliticasService
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.route.params.subscribe(async (params: Params) => {
      if (params['id'] ) {
        this.polDuraService
          .obtenerPorId(params['id'])
          .subscribe(async (politicaDura) => {
            this.policaDura = politicaDura;
            this.codigoValidacion =
              this.policaDura &&
              this.policaDura.codigotipoPoliticaDura !== 'TIPDOC' &&
              this.policaDura.codigotipoPoliticaDura !== 'BARPROD' &&
              this.policaDura.codigotipoPoliticaDura !== 'CIUNAPLI' &&
              this.policaDura.codigotipoPoliticaDura !== 'EDADMIN'
                ? 'PARAMETROS'
                : this.policaDura.codigotipoPoliticaDura
                  ? this.policaDura.codigotipoPoliticaDura
                  : '';

            if (this.codigoValidacion === 'BARPROD') {
              this.divisionPadre = await this.politicalDivisionServices
                .obtenerPadre(this.policaDura.idDivisionPolitica)
                .toPromise();
              if (this.divisionPadre) {
                await this.captureHoodId(this.divisionPadre, false);
              }
            }
            this.cargarInicial();
          });
      } else {
        this.policaDura = {} as PoliticaDura;
        this.cargarInicial();
      }
    });
  }

  async cargarFormulario() {
    let localizacion = null;
    if (this.policaDura && this.codigoValidacion === 'CIUNAPLI') {
      localizacion = {} as DivisionPolitica;
      localizacion.idDivisionPolitica = this.policaDura.idDivisionPolitica;
      localizacion.camino = this.policaDura.camino;
    } else if (
      this.policaDura &&
      this.divisionPadre &&
      this.codigoValidacion === 'BARPROD'
    ) {
      localizacion = {} as DivisionPolitica;
      localizacion.idDivisionPolitica = this.policaDura.idDivisionPolitica;
      localizacion.camino = this.divisionPadre.camino;
    }
    this.formulario = this.fb.group({
      idTipoPoliticaDura: [
        this.policaDura ? this.policaDura.idTipoPoliticaDura : null,
        [Validators.required],
      ],
      idListaParametro: [
        this.policaDura ? this.policaDura.idListaParametro : null,
      ],
      idDivisionPolitica: [
        this.policaDura ? this.policaDura.idDivisionPolitica : null,
      ],
      edadMin: [
        null
      ],
      edadMax: [
        null
      ],
      camino: [null],
      parametro: [this.policaDura ? this.policaDura.parametro : null],
    },{ validators: [this.validarRangoEdad()] });
    await this.validarRequeridos(true);
    this.carInformacionInicial = false;
    this.guardando = false;
  }

  async validarRequeridos(cargarInicial = false) {
    if (!cargarInicial) {
      this.resetearValidadores();
    }
    if (!this.f.idTipoPoliticaDura.value) {
      return;
    }
    const tipoPolitica = this.lisPoliticasDuras.find( (x) => x.idLista === this.f.idTipoPoliticaDura.value);
    switch (tipoPolitica.codigo) {
      case 'TIPDOC':
        this.codigoValidacion = 'TIPDOC';
        this.f.idListaParametro.setValidators(Validators.required);
        this.f.idListaParametro.setValue(this.policaDura.idPoliticaDura ? this.policaDura.idListaParametro : null);
        break;
      case 'BARPROD':
        this.codigoValidacion = 'BARPROD';
        this.f.idDivisionPolitica.setValidators(Validators.required);
        this.f.idDivisionPolitica.setValue(this.policaDura.idPoliticaDura ? this.policaDura.idDivisionPolitica : null);
        break;
      case 'CIUNAPLI':
        this.codigoValidacion = 'CIUNAPLI';
        if(!this.policaDura?.idPoliticaDura){
          const registro = {} as PoliticaDura;
          registro.idTipoPoliticaDura = this.f.idTipoPoliticaDura.value;
          registro.indicadorHabilitado = true;
          try {
            const resCrear = await this.polDuraService.crear(registro).toPromise();
            await this.autServicio.sendNotificationPoliticaDura(resCrear.idPoliticaDura).toPromise();
            this.policaDura = await this.polDuraService.obtenerPorId(resCrear.idPoliticaDura).toPromise();
          } catch (error) {
            console.error('Error en el flujo de creación de política dura', error);
          }
        }
        this.cargarTabla();
        this.busqueda = this.nav.getSearch( 'politicas-duras-editar.component' );
        if (this.table) {
          this.table.filterGlobal(this.busqueda, 'contains');
        }
        this.f.idDivisionPolitica.setValidators(Validators.required);
        this.f.idDivisionPolitica.setValue(this.policaDura.idPoliticaDura ? this.policaDura.idDivisionPolitica : null);
        break;
      case 'EDADMIN':
        this.codigoValidacion = 'EDADMIN';
        const rango = this.policaDura.parametro;
        const [edadMin, edadMax] = rango.split("-").map(Number);
        this.f.edadMin.setValue(edadMin ? edadMin : null);
        this.f.edadMax.setValue(edadMax ? edadMax : null);
        break;
      default:
        this.codigoValidacion = 'PARAMETROS';
        this.f.parametro.setValidators(Validators.required);
        this.f.parametro.setValue(this.policaDura.idPoliticaDura ? this.policaDura.parametro : null);
        break;
    }
  }

  resetearValidadores() {
    this.f.idListaParametro.setValidators(null);
    this.f.idListaParametro.setValue(null);
    this.f.idDivisionPolitica.setValidators(null);
    this.f.idDivisionPolitica.setValue(null);
    this.f.camino.setValidators(null);
    this.f.camino.setValue(null);
    this.f.parametro.setValidators(null);
    this.f.parametro.setValue(null);
  }

  /* validar y llenar las listas necesarias */
  validarLista() {
    this.selectPoliticasDuras = [];

    this.lisPoliticasDuras.forEach((x) => {
      const politicaCompleta = this.politicasDurasTodos.find(
        (p) => p.idTipoPoliticaDura === x.idLista
      );

      if (!politicaCompleta) return;

      const yaHabilitada = this.politicasDurasHabilitadas.some(
        (h) => h.codigotipoPoliticaDura === politicaCompleta.codigotipoPoliticaDura
      );

      if (!yaHabilitada) {
        this.selectPoliticasDuras.push({
          label: x.nombre,
          value: x.idLista,
        });
      }
    });

    if (this.policaDura && this.policaDura.idPoliticaDura) {
      this.selectPoliticasDuras.push({
        label: this.policaDura.tipoPoliticaDura,
        value: this.policaDura.idPoliticaDura,
      });
    }
  }


  cargarInicial() {
    this.lisPoliticasDuras = [];
    this.politicasDurasTodos = [];
    this.lisTiposDocumentos = [];
    this.selectPoliticasDuras = [];
    forkJoin(
      this.lisServicio.getMasterDetails('ListasPoliticasDurasPD'),
      this.lisServicio.getMasterDetails('ListasTiposDocumentos'),
      this.polDuraService.listado(),
      this.polDuraService.listadoHabilitados()
    ).subscribe(async ([lisPolDurasPD, lisTiposDocumentos, politicasDurasTodos, politicasDurasHabilitadas]) => {
      this.lisPoliticasDuras = lisPolDurasPD;
      this.politicasDurasTodos = politicasDurasTodos;
      this.politicasDurasHabilitadas = politicasDurasHabilitadas;
      lisTiposDocumentos.map((lisTipDoc) => {
        this.lisTiposDocumentos.push({
          label: lisTipDoc.nombre,
          value: lisTipDoc.idLista,
        });
      });
      this.validarLista();
      await this.cargarFormulario();
    });
  }

  async cargarTabla(){
    this.columnas = [
      {
        field: 'camino',
        header: this.nav.buscarMensaje('LBL_CIUDAD'),
        sort: true,
      },
      {
        field: 'det',
        header: this.nav.buscarMensaje('LBL_ACCIONES'),
        sort: false,
      }
    ];
    await this.cargarDatosTabla();
  }

  async cargarDatosTabla(){
    this.politicasDurasDivisionesPoliticasService.obtenerPorIdPoliticaDura(this.policaDura.idPoliticaDura).subscribe( data => {
      this.politicasDurasDivisionesPoliticas = data;
      console.log(data);
      this.carPoliticasDuras = false;
    });
  }

  onSubmit() {
    this.submitted = true;
    this.guardando = true;

    if (this.codigoValidacion === 'EDADMIN') {
      const edadMin = this.f.edadMin.value;
      const edadMax = this.f.edadMax.value;

      if ((edadMin == null || edadMin === '') && (edadMax == null || edadMax === '')) {
        this.nav.setMesage(0, {
          severity: 'error',
          summary: this.nav.buscarMensaje('LBL_INFORMACION'),
          detail: this.nav.buscarMensaje('POLITICASDURAS.MSG_ESREQUERIDO'),
        });

        this.guardando = false;
        return;
      }
    }

    if (this.formulario.valid) {
      const registro = this.formulario.value;
      if (this.policaDura.codigotipoPoliticaDura === 'EDADMIN') {
        registro.parametro = `${registro.edadMin}-${registro.edadMax}`
      }
      registro.camino = null;
      this.guardarPoliticasDuras(registro);
    } else {
      this.guardando = false;
    }
  }

  get f() {
    return this.formulario.controls;
  }

  guardarPoliticasDuras(registro: PoliticaDura) {
    const existe = this.politicasDurasTodos.find(
      (x) =>
        x.idTipoPoliticaDura === this.f.idTipoPoliticaDura.value &&
        (x.idDivisionPolitica ? (x.idDivisionPolitica === this.f.idDivisionPolitica.value) : false ||
          x.idListaParametro ? ( x.idListaParametro === this.f.idListaParametro.value) : false ||
          !!x.parametro)
    );
    if (existe && existe.indicadorHabilitado && (!this.policaDura || !this.policaDura.idPoliticaDura)) {
      this.nav.setMesage(0, {
        severity: 'info',
        summary: this.nav.buscarMensaje('LBL_INFORMACION'),
        detail: this.nav.buscarMensaje(
          'POLITICASDURAS.MSG_YAHAYUNAPOLITICA'
        ),
      });
      this.guardando = false;
      return;
    }

    if ((this.policaDura && this.policaDura.idPoliticaDura) || (existe && !existe.indicadorHabilitado)) {
      registro.idPoliticaDura = (this.policaDura && this.policaDura.idPoliticaDura)
        ? this.policaDura.idPoliticaDura
        : existe
        ? existe.idPoliticaDura
        : null;
      registro.indicadorHabilitado = true;
      this.polDuraService.actualizar(registro).subscribe(
        async (res) => {
          if (this.formulario.dirty) {
            this.autServicio.sendNotificationPoliticaDura(registro.idPoliticaDura ).toPromise();
          }
          this.nav.setMesage(1);
          this.formulario.reset();
          this.submitted = false;
          this.location.back();
          // this.policaDura = await this.polDuraService.obtenerPorId(res.idPoliticaDura).toPromise();
          this.cargarInicial();
        },
        (error) => {
          this.nav.setMesage(3);
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
        }
      );
    } else {
      this.polDuraService.crear(registro).subscribe(
        async (res) => {
          this.nav.setMesage(1);
          this.formulario.reset();
          this.submitted = false;
          this.location.back();
          this.autServicio.sendNotificationPoliticaDura(registro.idPoliticaDura ).toPromise();
          this.cargarInicial();
        },
        (error) => {
          this.nav.setMesage(3);
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
        }
      );
    }
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.nav.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.nav.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {},
      });
    } else {
      this.location.back();
    }
  }

  cambiarTabSeleccionado(tab: string) {
    this.tabSeleccionado = tab;
  }

 hoodSearch(event: any) {
  this.politicalDivisionServices.getAllCities(event.query).subscribe((hoods) => {
    const idsYaSeleccionados = this.politicasDurasDivisionesPoliticas.map(
      (p) => p.idDivisionPolitica
    );

    this.hoodList = hoods.filter(
      (hood) => !idsYaSeleccionados.includes(hood.idDivisionPolitica)
    );
  });
}


  crearCiudades(){
    if(this.ciudadesSeleccionadas.length >= 1){
      this.politicasDurasDivisionesPoliticasService.crearBulk(this.ciudadesSeleccionadas).subscribe(res => {
        this.cargarTabla();
        this.ciudadesSeleccionadas = [];
        this.nav.setMesage(1);
      })
    }else{
      this.nav.setMesage(3);
    }
  }

  captureHoodIdCiudad(event: any) {
  const ciudad = event.value;
  console.log(ciudad);


  const yaExiste = this.ciudadesSeleccionadas.some(
    (c) => c.idDivisionPolitica === ciudad.idDivisionPolitica
  );

  if (!yaExiste) {
    const nuevaCiudad: PoliticaDuraDivisionPolitica = {
      idPoliticaDuraDivisionPolitica: null,
      idDivisionPolitica: ciudad.idDivisionPolitica,
      idPoliticaDura: this.policaDura.idPoliticaDura,
      indicadorHabilitado: true,
      auditoriaFecha: new Date(),
      camino: ciudad.camino,
      descripcionDivisonPolitica: ciudad.descripcionDivisonPolitica
    };

    this.ciudadesSeleccionadas.push(nuevaCiudad);
  }

  this.f.camino.setValue(null);

  this.f.idDivisionPolitica.setValue(
    this.ciudadesSeleccionadas.map(c => c.idDivisionPolitica)
  );
}


  eliminarCiudad(ciudad: any) {
    this.ciudadesSeleccionadas = this.ciudadesSeleccionadas.filter(
      (c) => c.idDivisionPolitica !== ciudad.idDivisionPolitica
    );
    this.f.idDivisionPolitica.setValue(this.ciudadesSeleccionadas.map(c => c.idDivisionPolitica));
  }

  eliminarPoliticaDuraDivisionPolitica(ciudad: PoliticaDuraDivisionPolitica){
    ciudad.indicadorHabilitado = false;
    this.politicasDurasDivisionesPoliticasService.actualizar(ciudad).subscribe(res =>{
      this.cargarDatosTabla();
      this.nav.setMesage(2);
    })
  }

  async captureHoodId(event: any, reiniciar = true) {
    this.listNeighborhoods = [];
    this.neighborhoods = null;

    if (this.codigoValidacion === 'BARPROD') {
      const idDivisionPolitica = event && event.value ? event.value.idDivisionPolitica : event && event.idDivisionPolitica ? event.idDivisionPolitica : null;
      console.log( idDivisionPolitica );
      const barrio = this.politicalDivisionServices.getChildrenByIdFather( idDivisionPolitica ).toPromise();
      (await barrio).map((s: any) => {
        this.listNeighborhoods.push({
          label: s.descripcionDivisonPolitica,
          value: s.idDivisionPolitica,
        });
      });


      /* this.politicalDivisionServices
        .getChildrenByIdFather(event.idDivisionPolitica)
        .subscribe((rst) => {
          rst.map((s: any) => {
            if (s.indicadorHabilitado) {
              this.listNeighborhoods.push({
                label: s.descripcionDivisonPolitica,
                value: s.idDivisionPolitica,
              });
            }
          });
        }); */
      if (reiniciar) {
        this.f.idDivisionPolitica.setValue(event.value.idDivisionPolitica);
      }
    }
    if (reiniciar) {
      this.f.idDivisionPolitica.setValue(event.value.idDivisionPolitica);
    }
    this.badSelect = false;
    this.carInformacionInicial = false;
  }

  changeBarrio(event: any) {
    if (this.neighborhoods) {
      this.localizacion.locacion.camino = '';
      this.localizacion.locacion.camino =
        this.listNeighborhoods.find((x) => x.value === this.neighborhoods)
          .label +
        ', ' +
        this.city.camino;
      this.localizacion.locacion.idDivisionPolitica = this.neighborhoods;
      this.localizacion.idDivisionPolitica = this.neighborhoods;
      this.f.idDivisionPolitica.setValue(this.localizacion.idDivisionPolitica);
      // this.f.camino.setValue(this.localizacion.locacion.camino);
      // this.composeAddress();
      this.badSelectBarrio = false;
    } else {
      this.badSelectBarrio = true;
    }
  }

  validarRangoEdad(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const edadMin = group.get('edadMin')?.value;
      const edadMax = group.get('edadMax')?.value;

      if (
        edadMin != null && edadMax != null &&
        edadMin !== '' && edadMax !== '' &&
        edadMin >= edadMax
      ) {
        return { rangoInvalido: true };
      }

      return null;
    };
  }
  setSearch() {
    this.nav.setSearch( 'politicas-duras-editar.component', this.busqueda );
  }
}
